<template>
    <div class="grid">
        <div class="grid-item grid-item-full margin-bottom-s">
            <div class="grid-fitted grid-unstackable">
                <organization-logo :organization="organization"/>
                <div class="grid-item grid-item-half text-right">
                    <p class="stack-s" v-if="invoice.isTangible">Invoice {{invoice.invoiceNumberLabel}}</p>
                    <r-badge :type="getBadgeType('invoiceStatus', invoice.status)">{{invoice.statusLabel}}</r-badge>
                </div>
            </div>
        </div>
        <div class="grid-item grid-item-full margin-bottom-l">
            <div class="grid">
                <organization-context :invoice="invoice" @organization-loaded="organization = $event.organization"/>
                <div class="grid-item" v-fs-block>
                    <table class="table table-compact table-definition stack-xs table-v-alignment-top">
                        <tr>
                            <td class="no-wrap">Customer Id</td>
                            <td><router-link :to="{name: 'customer-details', params: {id: invoice.customerId}}">{{invoice.customerId}}</router-link></td>
                        </tr>
                        <tr>
                            <td>PO Number</td>
                            <td>
                                <v-inline-edit
                                    :disabled="invoice.isNotAllowedToUpdate"
                                    v-model="invoice.poNumber"
                                    @input="editInvoice('poNumber', $event)"/>
                            </td>
                        </tr>
                        <tr>
                            <td>Due Date</td>
                            <td>{{invoice.dueTime | tzDate(invoice.organization.invoiceTimeZone)}}</td>
                        </tr>
                        <tr>
                            <td>Issue Date</td>
                            <td>{{invoice.issuedTime | tzDate(invoice.organization.invoiceTimeZone)}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
        <div class="grid-item grid-item-full margin-bottom-m">
            <div class="grid">
                <div class="grid-item grid-item-half">
                    <h2 class="stack-s">Billed to</h2>
                    <v-contact :contact="invoice.billingAddress"/>
                </div>
                <div class="grid-item grid-item-half">
                    <h2 class="stack-s">Delivered to</h2>
                    <v-contact :contact="invoice.deliveryAddress"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {vInlineEdit} from '@/components/form';
    import vContact from '@/components/v-contact';
    import vInlineLoader from '@/components/v-inline-loader';
    import OrganizationContext from '@/modules/organizations/components/organization-context';
    import OrganizationLogo from '@/modules/organizations/components/organization-logo';
    import OrganizationModel from '@/common/models/organization-model';
    import ContactModel from '@/common/models/contact-model';
    import {getBadgeType} from '@/data/badges-color-map';

    export default {
        components: {
            vContact,
            vInlineEdit,
            vInlineLoader,
            OrganizationContext,
            OrganizationLogo,
        },
        props: {
            invoice: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                organization: new OrganizationModel(),
                organizationContact: new ContactModel(),
            };
        },
        methods: {
            getBadgeType,
            editInvoice(field, value) {
                this.$emit('update-invoice-field', {field, value});
            },
        },
    };
</script>
